module.exports = __webpack_public_path__ + "img/4681.30380ff4.jpg";